import { Highlight } from "../../Highlight";
import styles from "./InsuranceLayout.module.scss";
import { Section } from "../../Section";
import { SubHeader } from "../../SubHeader";
import { SectionHeader } from "../../SectionHeader";
import { getPartnerHeadings, PolicyDetails } from "shared";
import { getVehiclesLabel } from "../../../utils/vehicleUtils";
import { PartnerLogo } from "../../PartnerLogo/PartnerLogo";
import { ContactBroker } from "../ContactBroker";
import { EffectiveFrom } from "../../EffectiveFrom/EffectiveFrom";
import { formatPolicyNumber } from "../../../utils/formatPolicyNumber";
import { EnthusiastPolicyAlert } from "../EnthusiastPolicyAlert";
import { validateState } from "@hagerty/self-service-components/api/utils";

type InsuranceLayoutProps = {
  children: React.ReactNode;
  policy: PolicyDetails;
};

export function InsuranceLayout({ children, policy }: InsuranceLayoutProps) {
  const { broker, policyNumber, partner } = policy;
  const isApexPolicy = policy.source === "APEX";
  const vehicleNamesLabel = getVehiclesLabel(policy.vehicles);

  const { heading, accessibleHeading } = getPartnerHeadings(
    partner,
    validateState(policy.stateRegion),
    isApexPolicy
  );

  const ariaLabel = `${accessibleHeading} ${policyNumber} for ${vehicleNamesLabel}`;

  return (
    <Section
      ariaLabel={`${accessibleHeading} ${policyNumber}`}
      partner={partner}
    >
      {partner && <PartnerLogo partner={partner} />}
      <SectionHeader heading={heading} ariaLabel={ariaLabel}>
        {policyNumber && (
          <Highlight className={styles.highlight} ariaLabel="Policy number">
            #{formatPolicyNumber(policyNumber)}
          </Highlight>
        )}
      </SectionHeader>
      <SubHeader
        elements={[
          <EffectiveFrom
            effectiveDate={policy.effectiveDate}
            expirationDate={policy.expirationDate}
          />,
        ]}
      />
      {isApexPolicy && <EnthusiastPolicyAlert />}
      {broker && <ContactBroker partner={partner} broker={broker} />}
      <dl className="grid grid-wrap collapsed-gutters login-data-table_row">
        {children}
      </dl>
    </Section>
  );
}
